<template>
    <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.16344 0 0 7.16344 0 16H32C32 7.16344 24.8366 0 16 0Z" fill="#6100D4"/>
        <path d="M16 3C8.8203 3 3 8.8203 3 16H29C29 8.8203 23.1797 3 16 3Z" fill="#FF3815"/>
        <path d="M16 6C10.4772 6 6 10.4772 6 16H26C26 10.4772 21.5228 6 16 6Z" fill="#26E1ED"/>
        <path d="M16 9C12.134 9 9 12.134 9 16H23C23 12.134 19.866 9 16 9Z" fill="#FFA722"/>
        <path d="M16 12C13.7909 12 12 13.7909 12 16H20C20 13.7909 18.2091 12 16 12Z" fill="#18122A"/>
    </svg>
</template>
